var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row items-center"},[_c('div',{staticClass:"col-auto"},[_c('q-checkbox',{staticClass:"full-width",attrs:{"size":"xs","color":"secondary"},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1),_c('div',{staticClass:"q-ml-xs col text-caption ellipsis",class:[
      _vm.model ? 'text-dark text-weight-medium' : 'text-grey text-weight-normal',
    ]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }